module.exports = __webpack_public_path__ + "static/PRIMALOFT-84766a59175c74bd44fe5475c5078dca.svg";